import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { BrandSplash } from '@techsofit/ui';
import { api, ApiClientError } from '@techsofit/app-kit';

/** Exchanges a one-time support ticket (from the admin console) for a gym session cookie. */
export function SupportEnterPage() {
  const [params] = useSearchParams();
  const ticket = params.get('ticket') ?? '';
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!ticket) {
      setError('This support link is missing a ticket. Open support view again from the console.');
      return;
    }
    let alive = true;
    api('/account-auth/support-enter', { method: 'POST', body: { ticket } })
      .then(() => {
        if (!alive) return;
        window.location.replace('/dashboard');
      })
      .catch((err) => {
        if (!alive) return;
        setError(err instanceof ApiClientError ? err.message : 'Could not open support view. Try again from the console.');
      });
    return () => {
      alive = false;
    };
  }, [ticket]);

  if (error) {
    return (
      <div className="grid min-h-dvh place-items-center bg-canvas px-4">
        <p className="max-w-md text-center text-sm font-medium text-bad-ink">{error}</p>
      </div>
    );
  }
  return <BrandSplash />;
}
